var map = {
	"./app.svg": 49196,
	"./casino.svg": 946,
	"./jackpotTabBar.svg": 89260,
	"./lobby.svg": 33808,
	"./profile.svg": 71101,
	"./promo.svg": 83830,
	"./quest.svg": 51162,
	"./signout.svg": 92291,
	"./sports.svg": 99935,
	"./sportsMobileMenuIcon.svg": 86492,
	"./tournaments.svg": 46495,
	"./vip.svg": 65201
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96178;